import { createBrowserHistory } from "history";
// import ReactGA from 'react-ga'
// export const history = createBrowserHistory()

const history = createBrowserHistory({
  basename: "/thaiproducts/"
});

// history.listen(location => {
//     ReactGA.set({ page: location.pathname }); // Update the user's current page
//     ReactGA.pageview(location.pathname); // Record a pageview for the given page
//     console.log(`Logging pageview for history`)
// })

export { history };
